import React, { Component, Fragment } from 'react'
import SearchInput from './search-input'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

library.add(faSearch)


class SearchBar extends Component {
  render() {
    return(
      <Fragment>
        <SearchInput
          app={this.props.app}
          tAutocompleteSelection={this.props.tAutocompleteSelection}
          redirectType={this.props.redirectType}
          searchRedirect={this.props.searchRedirect}
          getSuggestion={this.props.getSuggestion}
          suggestions={this.props.suggestions}
          clearSuggestions={this.props.clearSuggestions}
        />
      </Fragment>
    )
  }
}

export default SearchBar